<template>
  <div>
    <div v-for="item in newsList" :key="item.id" class="flex py-5 border-b">
      <div class="w-13.5rem h-9rem">
        <img
          :src="$firstImage(item.viewimage, 'small')"
          class="img"
          v-if="item.viewimage"
        />
        <img src="@/assets/image/透明logo.png" class="img" v-else />
      </div>
      <div class="text-left pl-3">
        <p class="text-base font-semibold">{{ item.title }}</p>
        <p class="hid text-sm leading-8">
          {{ delHtmlTag(item.content) }}
        </p>
        <p class="flex flex-between text-sm">
          <span>{{ item.created.date }}</span>
          <span
            @click="viewDetails(item.id)"
            class="cursor-pointer text-gray-400"
            >{{ $t("查看详情") }}></span
          >
        </p>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="newsTotal"
      :page-size="6"
      @current-change="handleCurrentChange"
      :hide-on-single-page="true"
    ></el-pagination>
  </div>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const newsList = ref();
    //新闻总数
    const newsTotal = ref();
    const getNewsList = async (page) => {
      const res = await ctx.root.$callapi("news/getNewsList", {
        page: page,
        size: 6,
        tag: "news",
      });
      newsList.value = res.data.items;
      newsTotal.value = res.data.total;
    };
    onMounted(() => {
      getNewsList(1);
    });
    //查看详情
    const viewDetails = (id) => {
      ctx.root.$router.push({
        name: "newsDetail",
        query: { id: id, tag: "newsDetail" },
      });
    };
    //下一页
    const handleCurrentChange = (val) => {
      getNewsList(val);
    };
    //去除html 标签
    const delHtmlTag = (str) => {
      return str.replace(/<[^>]+>/g, "");
    };

    return {
      newsList,
      newsTotal,
      viewDetails,
      handleCurrentChange,
      delHtmlTag,
    };
  },
};
</script>
<style scoped lang="scss">
.hid {
  width: 54rem;
  height: 6rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>